import colors from '@/config/colors';

// default belongs to either the wordset or the sentenceset
export const TASKS = {
  default: [
    {
      label: 'Auditives Sprachverständnis',
      iconName: 'ear-outline',
      iconLibrary: 'Ionicons',
      exerciseSettingsKey: 'Verstehen',
    },
    {
      label: 'Mündliches Benennen',
      iconName: 'bubble',
      iconLibrary: 'SimpleLineIcons',
      exerciseSettingsKey: 'Sprechen',
    },
    {
      label: 'Lesesinnverständnis',
      iconName: 'book-open',
      iconLibrary: 'SimpleLineIcons',
      exerciseSettingsKey: 'Lesen',
    },
    {
      label: 'Schriftliches Benennen',
      iconName: 'pencil-outline',
      iconLibrary: 'Ionicons',
      exerciseSettingsKey: 'Schreiben',
    },
  ],
  text: [
    {
      label: 'Auditives Sprachverständnis',
      iconName: 'ear-outline',
      iconLibrary: 'Ionicons',
      exerciseSettingsKey: 'Verstehen',
    },
    {
      label: 'Mündliches Nacherzählen',
      iconName: 'bubble',
      iconLibrary: 'SimpleLineIcons',
      exerciseSettingsKey: 'Sprechen',
    },
    {
      label: 'Lesesinnverständnis',
      iconName: 'book-open',
      iconLibrary: 'SimpleLineIcons',
      exerciseSettingsKey: 'Lesen',
    },
    {
      label: 'Schreiben',
      iconName: 'pencil-outline',
      iconLibrary: 'Ionicons',
      exerciseSettingsKey: 'Schreiben',
    },
  ],
};

export const HEADER_BTNS = {
  word: {
    defaultBtns: [
      {
        label: 'Zielwort',
        iconName: {
          true: 'volume-medium',
          false: 'volume-off',
        },
        iconNameValue: 'isPlaying',
        functionName: 'playSound',
        iconLibrary: 'Ionicons',
      },
      {
        label: 'variable',
        iconName: 'eye',
        iconLibrary: 'Ionicons',
        functionName: 'showZielwort',
      },
    ],
    Schreiben: [
      {
        label: 'Spicken',
        iconName: 'eye',
        iconLibrary: 'Ionicons',
        pressIn: 'peekIn',
        pressOut: 'peekOut',
        notOnPress: true,
      },
      {
        label: 'Zielwort',
        iconName: {
          true: 'volume-medium',
          false: 'volume-off',
        },
        iconNameValue: 'isPlaying',
        functionName: 'playSound',
        iconLibrary: 'Ionicons',
      },
      {
        label: 'variable',
        iconName: 'eye',
        iconLibrary: 'Ionicons',
        functionName: 'showZielwort',
      },
    ],
    Sprechen: [
      {
        label: 'Zielwort',
        iconName: {
          true: 'volume-medium',
          false: 'volume-off',
        },
        iconNameValue: 'isPlaying',
        functionName: 'playSound',
        iconLibrary: 'Ionicons',
      },
      {
        label: 'variable',
        iconName: 'eye',
        iconLibrary: 'Ionicons',
        functionName: 'showZielwort',
      },
      {
        label: 'Falsch',
        iconName: 'x-circle',
        iconLibrary: 'Feather',
        isDark: true,
        functionParam: 'Falsch',
        backgroundColor: colors.newUI.therapist.blue50,
        functionName: 'changeSelectedPerformance',
      },
      {
        label: 'Fast',
        iconName: 'questioncircleo',
        iconLibrary: 'AntDesign',
        isDark: true,
        functionParam: 'Fast',
        backgroundColor: colors.newUI.therapist.blue50,
        functionName: 'changeSelectedPerformance',
      },
      {
        label: 'Richtig',
        iconName: 'checkcircleo',
        iconLibrary: 'AntDesign',
        isDark: true,
        functionParam: 'Richtig',
        backgroundColor: colors.newUI.therapist.blue50,
        functionName: 'changeSelectedPerformance',
      },
    ],
  },
  sentence: {
    defaultBtns: [
      {
        label: 'Zielsatz',
        iconName: {
          true: 'volume-medium',
          false: 'volume-off',
        },
        iconNameValue: 'isPlaying',
        functionName: 'playSound',
        iconLibrary: 'Ionicons',
      },
      {
        label: 'variable',
        iconName: 'eye',
        iconLibrary: 'Ionicons',
        functionName: 'showZielwort',
      },
    ],
    Schreiben: [
      {
        label: 'Spicken',
        iconName: 'eye',
        iconLibrary: 'Ionicons',
        pressIn: 'peekIn',
        pressOut: 'peekOut',
        notOnPress: true,
      },
      {
        label: 'Zielsatz',
        iconName: {
          true: 'volume-medium',
          false: 'volume-off',
        },
        iconNameValue: 'isPlaying',
        functionName: 'playSound',
        iconLibrary: 'Ionicons',
      },
      {
        label: 'variable',
        iconName: 'eye',
        iconLibrary: 'Ionicons',
        functionName: 'showZielwort',
      },
    ],
    Sprechen: [
      {
        label: 'Zielsatz',
        iconName: {
          true: 'volume-medium',
          false: 'volume-off',
        },
        iconNameValue: 'isPlaying',
        functionName: 'playSound',
        iconLibrary: 'Ionicons',
      },
      {
        label: 'variable',
        iconName: 'eye',
        iconLibrary: 'Ionicons',
        functionName: 'showZielwort',
      },
      {
        label: 'Falsch',
        iconName: 'x-circle',
        iconLibrary: 'Feather',
        isDark: true,
        functionParam: 'Falsch',
        backgroundColor: colors.newUI.therapist.blue50,
        functionName: 'changeSelectedPerformance',
      },
      {
        label: 'Fast',
        iconName: 'questioncircleo',
        iconLibrary: 'AntDesign',
        isDark: true,
        functionParam: 'Fast',
        backgroundColor: colors.newUI.therapist.blue50,
        functionName: 'changeSelectedPerformance',
      },
      {
        label: 'Richtig',
        iconName: 'checkcircleo',
        iconLibrary: 'AntDesign',
        isDark: true,
        functionParam: 'Richtig',
        backgroundColor: colors.newUI.therapist.blue50,
        functionName: 'changeSelectedPerformance',
      },
    ],
  },
};
